import { Context, createContext, RefObject } from 'react';

import { IQATestableProps } from '../../shared/types/IQATestableProps';

import { DOT_PAGINATION_VARIANTS } from './DOT_PAGINATION_VARIANTS';
import { getDefaultNavState } from './navState/getDefaultNavState';
import { INavState } from './navState/navState';

export type IDotPaginationContext = IQATestableProps & {
    variant: DOT_PAGINATION_VARIANTS;
    totalPages: number;
    navState: INavState;
    addDotRef: (dotRef: RefObject<HTMLButtonElement>) => void;
};

function noOp (..._args: any[]): void {
    /* intentionally empty */
}

export const DotPaginationContext: Context<IDotPaginationContext> = createContext<IDotPaginationContext>({
    variant: DOT_PAGINATION_VARIANTS.LIGHT,
    totalPages: 0,
    navState: getDefaultNavState(0),
    addDotRef: noOp,
});
